import {observable} from "@myshared/mobx-connector";
import {runInAction} from "mobx";

export class ConfigModel {
  @observable public authUrl: string;
  @observable public apiDocsUrl: string;

  constructor() {
    runInAction(() => {
      this.authUrl = '';
      this.apiDocsUrl = '';
    })
  }
}
